import { Link } from 'react-router-dom';
import { FadeUp } from './Motion.jsx';
import cardVial from '../assets/images/card-vial.png';
import cardNeck from '../assets/images/card-neck.png';
import cardPdt from '../assets/images/card-pdt.png';

const cards = [
  { id: 'pdt', title: 'Photodynamic therapy', desc: 'Lasers, fibres and photosensitisers as one platform.', to: '/pdt', image: cardPdt },
  { id: 'indication', title: 'Head & neck cancer', desc: 'Background, symptoms and treatment options.', to: '/head-neck-cancer', image: cardNeck },
  { id: 'adverse-event-report', title: 'Adverse event report', desc: 'Regulatory reporting and pharmacovigilance.', to: '/adverse-event-report', image: cardVial, pad: true },
];

export default function FeatureCards() {
  return (
    <section className="cards-v2">
      {cards.map((card, i) => (
        <FadeUp key={card.id} delay={i * 0.1}>
          <Link to={card.to} className="card-v2" id={card.id}>
            <span className={`card-v2-media${card.pad ? ' card-v2-media--pad' : ''}`}>
              <img src={card.image} alt="" aria-hidden="true" />
            </span>
            <span className="card-v2-body">
              <span className="card-v2-title">{card.title}</span>
              <span className="card-v2-desc">{card.desc}</span>
            </span>
            <span className="card-v2-arrow" aria-hidden="true">&rarr;</span>
          </Link>
        </FadeUp>
      ))}
    </section>
  );
}